import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADVANCE_WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const WaveList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.number, show: false },
			{ Header: 'waveNumber', accessor: 'waveNumber', filterType: FilterType.string, showOnMobile: true },
			{ Header: 'fullName', accessor: 'fullName', filterType: FilterType.string },
			{
				Header: 'orderIds',
				accessor: 'orderIds',
				filterType: FilterType.string,
				showOnMobile: true,
				customFilterOptions: [FilterAction.is, FilterAction.multipleFilter],
				customHeaderFilterAction: FilterAction.is
			},
			{ Header: 'binName', accessor: 'binName', filterType: FilterType.string },
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'startDate',
				accessor: 'startDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'completeDate',
				accessor: 'completionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			},
			{
				Header: 'pickerGroup',
				accessor: 'pickerGroup',
				filterType: FilterType.string,
				width: 90,
				show: false
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);
	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.WAVE_LIST}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={ADVANCE_WMS_MODULE.GET_WAVES_LIST}
				exportName="wavePicking"
				actionObjectType={ACTION_OBJECT_TYPES.WMS}
			/>
		</TabTableContainer>
	);
};

export default WaveList;
